import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import Box, { BoxProps } from "@mui/material/Box";
import { EmtLoader } from "./EmtLoader";

export type EmtButtonProps = ButtonProps & {
  /**
   * Define if loader is active or not
   * @default false
   */
  loader?: boolean;
  /**
   * If true, the button will be fixed at the bottom center of the screen.
   * @default false
   */
  fixedBottom?: boolean;
  nonce?: string;
  onResizeCapture?: any;
  onResize?: any;
  color?: any;
  variant?: any;
  boxProps?: BoxProps;
};

export const EmtButton: JSX.Element & any = React.forwardRef<
  HTMLButtonElement,
  EmtButtonProps
>((componentProps, ref) => {
  const {
    variant = "contained",
    loader = false,
    disabled,
    fixedBottom = false,
    boxProps,
    ...rest
  } = componentProps;

  return (
    <Box
      {...boxProps}
      sx={{
        position: fixedBottom ? "fixed" : "relative",
        bottom: fixedBottom ? 40 : "auto",
        left: fixedBottom ? "50%" : "auto",
        transform: fixedBottom ? "translateX(-50%)" : "none",
        width: rest.fullWidth || fixedBottom ? "100%" : "auto",
        display: fixedBottom ? "flex" : "inline-flex",
        justifyContent: "center",
        zIndex: fixedBottom ? 1300 : "auto",
        p: fixedBottom ? 2 : 0,
        ...boxProps?.sx,
      }}
    >
      <Button
        {...rest}
        variant={variant}
        ref={ref}
        disabled={loader ? true : disabled}
      />
      {loader && (
        <EmtLoader
          size={22}
          color={rest.color}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-10px",
            marginLeft: "-12px",
          }}
        />
      )}
    </Box>
  );
});

EmtButton.displayName = "EmtButton";
